import React, { Fragment, useState } from 'react';
import { Container } from 'react-bootstrap';
import HeaderLogged from '../../../../components/header_logged'
import Footer from '../../../../components/footer'
import Head from '../../../../components/head';
import Indice from '../../../../components/auth/leis/indiceleis'


function IndiceLeiScreen() {

    return (
        <Fragment>
            <Head titulo="Índice de Leis Cadastradas - Módulo Legislativo" />
            <HeaderLogged />
            <Container>
               <Indice />
            </Container>
            <Footer />
        </Fragment>
    );
}

export default IndiceLeiScreen;